import {RouteInfo} from './sidebar.metadata';

export const ROUTES: RouteInfo[] = [
  {
    id: "partnerbranch",
    path: '/partnerbranch',
    title: 'Switch Branch',
    icon: 'mdi mdi-account-convert',
    class: '',
    label: '',
    labelClass: '',
    extralink: false,
    submenu: []
  }, {
    id: "dashboard",
    path: '/dashboard',
    title: 'Home',
    icon: 'mdi mdi-home',
    class: '',
    label: '',
    labelClass: '',
    extralink: false,
    submenu: []
  }, {
    id: "lead",
    path: '/lead',
    title: 'Lead',
    icon: 'mdi mdi-bullseye',
    class: '',
    label: '',
    labelClass: '',
    extralink: false,
    submenu: []
  }, {
    id: "application",
    path: '/application',
    title: 'Application Status',
    icon: 'mdi mdi-application',
    class: '',
    label: '',
    labelClass: '',
    extralink: false,
    submenu: [{
      id: 'applicationPS',
      path: '/application?status=partnerstage',
      title: 'In Partner Stage',
      icon: '',
      class: '',
      label: '',
      labelClass: '',
      extralink: false,
      submenu: []
    }, {
      id: 'applicationCS',
      path: '/application?status=customerstage',
      title: 'In Customer Stage',
      icon: '',
      class: '',
      label: '',
      labelClass: '',
      extralink: false,
      submenu: []
    }, {
      id: 'applicationCR',
      path: '/application?status=cancelrefused',
      title: 'Cancel/Rejected',
      icon: '',
      class: '',
      label: '',
      labelClass: '',
      extralink: false,
      submenu: []
    }, {
      id: 'applicationAllCR',
      path: '/application?review=credit',
      title: 'Reject Relook',
      icon: '',
      class: '',
      label: '',
      labelClass: '',
      extralink: false,
      submenu: []
    }, {
      id: 'applicationAllSR',
      path: '/application?review=sales',
      title: 'Document Pending',
      icon: '',
      class: '',
      label: '',
      labelClass: '',
      extralink: false,
      submenu: []
    }, {
      id: 'applicationAll',
      path: '/application',
      title: 'All',
      icon: '',
      class: '',
      label: '',
      labelClass: '',
      extralink: false,
      submenu: []
    }]
  }, {
    id: "loans",
    path: '/loans',
    title: 'Loans',
    icon: 'mdi mdi-cash-multiple',
    class: '',
    label: '',
    labelClass: '',
    extralink: false,
    submenu: [
      {
        id: 'loansEmandate',
        path: '/loans?status=emandate',
        title: 'Esign Stage',
        icon: '',
        class: '',
        label: '',
        labelClass: '',
        extralink: false,
        submenu: [],
      },
      {
        id: 'loansVerify',
        path: '/loans?status=toVerify',
        title: 'To Verify',
        icon: '',
        class: '',
        label: '',
        labelClass: '',
        extralink: false,
        submenu: [],
      },
 
      {
        id: 'loansToDisburse',
        path: '/loans?status=toDisburse',
        title: 'To Disburse',
        icon: '',
        class: '',
        label: '',
        labelClass: '',
        extralink: false,
        submenu: [],
      },
      
      {
        id: 'loansAll',
        path: '/loans',
        title: 'All',
        icon: '',
        class: '',
        label: '',
        labelClass: '',
        extralink: false,
        submenu: [],
      }]
  }
];

